import { render, staticRenderFns } from "./PreviewOrganiserDepositsReminderEmail.vue?vue&type=template&id=0435bc94&scoped=true"
import script from "./PreviewOrganiserDepositsReminderEmail.vue?vue&type=script&lang=js"
export * from "./PreviewOrganiserDepositsReminderEmail.vue?vue&type=script&lang=js"
import style0 from "./PreviewOrganiserDepositsReminderEmail.vue?vue&type=style&index=0&id=0435bc94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0435bc94",
  null
  
)

export default component.exports